<template>
	<ul class="!m-0 !mb-4 flex flex-col !p-0 !pb-4">
		<li :id="category.title" v-for="(category, index) in options" :key="`${category.title}-${index}`">
			<Disclosure as="div">
				<DisclosureButton
					class="w-full flex justify-between items-center !py-5 !border-t-swatch border-solid border-b-0 border-x-0 !border-t-zinc-400"
					@click="() => handleClick(category.title)"
				>
					<div class="flex items-center gap-1.5">
						<span class="!pe-2 text-xs font-medium uppercase tracking-widest">
							{{ category.title }}
						</span>
						<pb-category-count :category-title="category.title" />
					</div>
					<svg-vue v-if="showCategory(category.title)" icon="accordion-minus" class="w-4 stroke-white shrink-0" />
					<svg-vue v-else icon="accordion-plus" class="w-4 stroke-white shrink-0" />
				</DisclosureButton>
				<div v-show="showCategory(category.title)">
					<DisclosurePanel static>
						<ul class="!m-0 flex flex-col gap-6 !p-0 !py-3">
							<template v-if="category.areVariantsGrouped">
								<headless-tabs :tabs="category.variantTabs" panel-style="!mt-2 !mb-4">
									<template
										v-for="(variants, variantLabel) in category.variants"
										:key="`${variantLabel}--${index}`"
										v-slot:[transformSlot(variantLabel)]
									>
										<ul class="!m-0 flex flex-col gap-6 !p-0 !pt-5">
											<li
												v-for="variant in variants"
												:key="`${variant.title}---${index}`"
												class="grid grid-cols-[80px_1fr] gap-3"
											>
												<pb-item-quantity :category-title="category.title" :item="variant" :disabled="variant.oos">
													<template v-slot:info>
														<div class="[&_p]:!m-0 [&_p]:!p-0">
															<p class="inline-flex items-center gap-2 text-sm">
																{{ variant.title }}
																<template v-if="variant.oos">
																	<span class="text-xs text-orange-800"> Out Of Stock </span>
																</template>
															</p>
															<p class="!text-black !m-0 flex items-center gap-x-1 !p-0">
																<span class="flex items-center gap-x-0 text-[13px]/[16px] font-medium">
																	{{ variant.price }}
																</span>
																<template v-if="variant.original">
																	<span class="text-line-through text-[11px]/[16px] font-normal text-neutral-600">
																		{{ variant.original }}
																	</span>
																</template>
																<template v-if="variant.savings">
																	<span class="text-[11px]/[16px] font-normal text-orange-800">
																		{{ variant.savings }}
																	</span>
																</template>
															</p>
														</div>
													</template>
												</pb-item-quantity>
											</li>
										</ul>
									</template>
								</headless-tabs>
							</template>
							<template v-else>
								<li
									v-for="variant in category.variants"
									:key="`${variant.title}---${index}`"
									class="grid grid-cols-[80px_1fr] gap-3"
								>
									<pb-item-quantity :category-title="category.title" :item="variant" :disabled="variant.oos">
										<template v-slot:info>
											<div class="[&_p]:!m-0 [&_p]:!p-0">
												<p class="inline-flex items-center gap-2 text-sm">
													{{ variant.title }}
													<template v-if="variant.oos">
														<span class="text-xs text-orange-800"> Out Of Stock </span>
													</template>
												</p>
												<p class="!text-black !m-0 flex items-center gap-x-1 !p-0">
													<span class="flex items-center gap-x-0 text-[13px]/[16px] font-medium">
														{{ variant.price }}
													</span>
													<template v-if="variant.original">
														<span class="text-line-through text-[11px]/[16px] font-normal text-neutral-600">
															{{ variant.original }}
														</span>
													</template>
													<template v-if="variant.savings">
														<span class="text-[11px]/[16px] font-normal text-orange-800">
															{{ variant.savings }}
														</span>
													</template>
												</p>
											</div>
										</template>
									</pb-item-quantity>
								</li>
							</template>
						</ul>
					</DisclosurePanel>
				</div>
			</Disclosure>
		</li>
	</ul>
</template>
<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({
	options: {
		type: Array,
		required: true,
	},
})

const store = usePaletteBuilderStore()
const { handleStackRefresh } = store

const activeAccordion = ref(null)

onMounted(() => {
	nextTick(() => handleStackRefresh())
})

const handleClick = (str) => {
	const title = str.replace(/ /g, '')
	if (title === activeAccordion.value) {
		activeAccordion.value = null
		return
	}

	activeAccordion.value = title
	nextTick(() => {
		const el = document.getElementById(title)
		if (el) {
			el.scrollIntoView({ behavior: 'smooth' })
		}
	})
}
const transformSlot = (str) => str.replace(' ', '-')
const showCategory = (title) => activeAccordion.value === title.replace(/ /g, '')
</script>
